import { useState } from "react";
import { Mrz } from "../passapp-sdk/models/Mrz";
import { getSeparator } from "../utils/scannerSeparators";
import { useStore } from "./useStore";
import { checkDni } from "../shared/ManualSearchForm/ManualSearchForm";

const useScanPDF417 = () => {
  const { authStore } = useStore();
  const [resultPDF, setResultPDF] = useState<Mrz | null>(null);
  const generateUserPDF = (result: string): Mrz => {
    let user: Mrz;
    const data: Mrz = {
      dni: "",
      sex: "",
      country: "",
      firstname: "",
      lastname: "",
      mrz: [],
    };
    if (result) {
      const separator = getSeparator(result);
      const dataResult = result.split(separator);
      if (dataResult[0] === separator || dataResult[0] === "") {
        user = getOldDNI(dataResult, data);
      } else {
        user = getNewDNI(dataResult, data);
      }
      return user;
    } else {
      return data;
    }
  };

  const getNewDNI = (dataResult: string[], data: Mrz): Mrz => {
    data.dni = dataResult[4];
    data.firstname = dataResult[2];
    data.lastname = dataResult[1];
    const country: any = authStore.country;
    data.country = country?.code || "ARG";
    data.sex = dataResult[3];
    data.birthdate = dataResult[6];
    data.mrz = dataResult;
    return data;
  };

  const getOldDNI = (dataResult: string[], data: Mrz): Mrz => {
    data.dni = dataResult[1].trim();
    data.firstname = dataResult[5];
    data.lastname = dataResult[4];
    data.country = dataResult[6].substring(0, 3);
    data.sex = dataResult[8];
    data.mrz = dataResult;
    return data;
  };

  const scanPDF = (result: string) => {
    const user = generateUserPDF(result);
    if (checkDni(user.dni)) {
      setResultPDF(user);
    }
  };

  const resetPDF = () => {
    setResultPDF(null);
  };

  return { scanPDF, resultPDF, resetPDF };
};

export default useScanPDF417;
